<template>
  <div class="uk-card uk-card-default uk-card-small">
    <div class="uk-card-body">
      <div class="uk-grid uk-grid-small" data-uk-grid>
        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.makes"
            v-model="selected.make"
            :reduce="make => make.value"
            placeholder="Hersteller wählen"
          >
          </v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="availableModels"
            :reduce="model => model.value"
            placeholder="Modell wählen"
            v-model="selected.model"
            @input="onModelChange()"
          >
            <span slot="no-options">Bitte Hersteller wählen</span>
            <template v-slot:option="option">
              <span v-if="option.id && option.group" style="margin-left: 10px;">{{ option.label }}</span>
              <span v-else>{{ option.label }}</span>
            </template>
          </v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.fueltype"
            v-model="selected.fueltype"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Kraftstoff wählen"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.locations"
            v-model="selected.location"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Standort"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="firstregdates"
            v-model="selected.firstregdateMin"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Erstzulassung von"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="firstregdates"
            v-model="selected.firstregdateMax"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Erstzulassung bis"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="mileages"
            v-model="selected.mileageMin"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Kilometer von"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="mileages"
            v-model="selected.mileageMax"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Kilometer bis"
          ></v-select>
        </div>

        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.transmission"
            v-model="selected.transmission"
            @input="activateFilter"
            :searchable="false"
            :reduce="filter => filter.value"
            placeholder="Getriebe wählen"
          ></v-select>
        </div>
        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.category"
            v-model="selected.category"
            @input="activateFilter"
            :reduce="filter => filter.value"
            placeholder="Bauform wählen"
            :searchable="false"
          ></v-select>
        </div>

        <div class="uk-width-1-4@m">
          <v-select
            :options="filters.currentstatus"
            v-model="selected.currentstatus"
            :searchable="false"
            @input="activateFilter"
            :reduce="filter => filter.value"
            placeholder="Fahrzeugtyp wählen"
          ></v-select>
        </div>
         <div class="uk-width-1-4@m">
          <v-select
            :options="filters.availability"
            v-model="selected.availability"
            :searchable="false"
            @input="activateFilter"
            :reduce="filter => filter.value"
            placeholder="Verfügbarkeit wählen"
          ></v-select>
        </div>

        <div class="uk-width-1-4@m">
          <div class="uk-search uk-search-default">
            <a href="#" class="uk-search-icon-flip" uk-search-icon v-if="selected.carId" @click.prevent="activateFilter"></a>
            <input v-model="selected.carId" @keyup.enter="activateFilter" type="text" class="uk-input" placeholder="Fahrzeugnummer">
          </div>
        </div>
        <div class="uk-width-1-1 detail-search" hidden>
          <hr class="uk-margin-medium" />
          <div class="uk-grid uk-grid-small" data-uk-grid>
            <div class="uk-width-1-4@m">
              <v-select
                :options="filters.color"
                v-model="selected.color"
                @input="activateFilter"
                :searchable="false"
                :reduce="filter => filter.value"
                placeholder="Grundfarbe"
              ></v-select>
            </div>
            <div class="uk-width-1-4@m">
              <v-select
                :options="powerValues"
                v-model="selected.powerMin"
                @input="activateFilter"
                :searchable="false"
                :reduce="filter => filter.value"
                placeholder="Leistung von"
              ></v-select>
            </div>
            <div class="uk-width-1-4@m">
              <v-select
                :options="powerValues"
                v-model="selected.powerMax"
                @input="activateFilter"
                :searchable="false"
                :reduce="filter => filter.value"
                placeholder="Leistung bis"
              ></v-select>
            </div>
            <div class="uk-width-1-4@m">
              <v-select
                :options="trailerValues"
                v-model="selected.trailer"
                @input="activateFilter"
                :searchable="false"
                :reduce="filter => filter.value"
                placeholder="Anhängerkupplung"
              ></v-select>
            </div>
          </div>
          <div class="uk-grid uk-grid-small uk-child-width-1-3@m" data-uk-grid v-if="filters.customFeatures">
            <div v-for="(chunked, ck) in chunkedItems(filters.customFeatures.features)" :key="ck">
              <ul class="uk-list uk-margin-remove">
                <li v-for="(filter, value) in chunked" :key="value" class="uk-margin-remove">
                  <label>
                    <input
                      class="uk-checkbox"
                      type="checkbox"
                      :value="filter.value || filter"
                      v-model="selected.features"
                      @change="activateFilter"
                    />
                    {{ filter.label || filter }}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="uk-width-1-1 uk-text-right">
          <button class="uk-button uk-button-link" style="text-transform: none" @click.prevent="clearFilter">
            Alles zurücksetzen
          </button>
          <button
            class="uk-button uk-button-link uk-text-capitalize uk-margin-left"
            data-uk-toggle="target: .detail-search"
          >
            <span class="detail-search uk-text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                style="width: 15px; height: 15px"
              >
                <path
                  fill-rule="evenodd"
                  d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <span class="detail-search uk-text-primary" hidden>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                style="width: 15px; height: 15px"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            Detailsuche
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import Firstregdates from '@/assets/json/firstregdates.json'
import Prices from '@/assets/json/prices.json'
import Mileages from '@/assets/json/mileages.json'
import PowerValues from '@/assets/json/power.json'
import OpenIndicator from '@/components/OpenIndicator.vue'
vSelect.props.components.default = () => ({
  OpenIndicator: OpenIndicator
})

import queryString from 'query-string'
import _ from 'lodash'
export default {
  props: {
    filters: {
      required: false
    }
  },
  data() {
    return {
      currentCount: null,
      selected: {},
      firstregdates: Firstregdates,
      prices: Prices,
      mileages: Mileages,
      powerValues: PowerValues,
      trailerValues: [{
        label: 'Fest, abnehmbar oder schwenkbar',
        value: '206,207,209'
      },{
        label: 'Abnehmbar oder schwenkbar',
        value: '207,209'
      },{
        label: 'Schwenkbar',
        value: '209'
      }],
      selectedMakeModels: {
        make: null,
        model: null
      }
    }
  },
  components: {
    vSelect
  },

  mounted() {
    setTimeout(() => {
      this.getSelectedFilters()
    }, 500)
  },
  computed: {
    ...mapGetters(['tenant']),
    availableModels() {
      const selectedMakeObj = _.find(this.filters.makes, m => {
        return m.value === this.selected.make
      })

      return selectedMakeObj ? selectedMakeObj.models : []
    }
  },
  watch: {
    'selected.make': function(val, oldVal) {
      if (typeof oldVal !== 'undefined' && oldVal !== null && val !== oldVal) {
        this.selected.model = null
      }

      this.onModelChange()
    },
    '$route.query'() {
      this.getSelectedFilters()
    }
  },
  methods: {
    getSelectedFilters() {
      let checkboxFilters = []
      checkboxFilters.push('features')

      let initFiltersArr = _.map(this.filters, (value, key) => {
        if (value.type === 'checkbox') {
          checkboxFilters.push(key)
        }
        return { key: key, value: value.type === 'checkbox' ? [] : null }
      })

      const initFilters = _.mapValues(_.keyBy(initFiltersArr, 'key'), 'value')

      let q = _.map(this.$route.query, (value, key) => {
        if (value === '!1') {
          return false
        }
        if (checkboxFilters.includes(key)) {
          return { [key]: !value.includes(',') ? [value] : value.split(',') }
        }
        return {
          [key]: isNaN(parseInt(value)) || value.includes('-') ? value : parseInt(value)
        }
      })
      initFilters.features = []
      initFilters.trailer = null
      initFilters.powerMin = null,
      initFilters.powerMax = null

      this.selected = _.omit(_.merge(initFilters, Object.assign({}, ...q)), ['page'])

      this.selectedMakeModels = {
        make: this.selected.make || null,
        model: this.selected.model || null
      }
    },
    activateFilter(key, value) {
      if (key) {
        this.selected[key] = value
      }

      this.selected = _(this.selected)
        .omitBy(_.isNull)
        .omit('query')
        .value()

      const query = queryString.stringify(this.selected, {
        arrayFormat: 'comma'
      })

      this.$router.push(`?${query}`).catch(err => {
        console.log(err)
      })
    },
    onModelChange() {
      this.activateFilter()
    },
    chunkedItems(items) {
      return _.chunk(items, Math.ceil(items.length / 3))
    },
    clearFilter() {
      this.selected = {}
      this.selectedMakeModels = {}
      this.$router.replace({
        name: 'VehicleIndex',
        params: { ...this.$route.params }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.uk-button-link {
  font-size: 1rem;
  color: #333;
}
</style>
